.base {
	display: flex;
}

.basic {
	gap: var(--lp-size-10);
}

.compact {
	composes: buttonGroup from './base.module.css';
	gap: initial;
}

.large {
	gap: var(--lp-spacing-600);
}

.horizontal {
	flex-direction: row;
}

.vertical {
	flex-direction: column;
}
